<template>
  <div class="content_box">
    <div class="content_box_inner">
      <div class="headTitle">
        <img src="@/assets/imgs/icon/icon_project.png" alt />
        项目库
        <span class="noticeFont">（点击表格首列箭头可展开详情）</span>
      </div>
      <div class="topBtnBox">
        <el-row style="width: 100%">
          <el-col :xs="24" :lg="8">
            <div class="searchBtn">
              <el-button type="primary" class="bg5584FF" @click="openSeach">
                高级查询选项&emsp;
                <i
                  :class="[
                    'el-icon-caret-top',
                    { show: showSearch, close: !showSearch },
                  ]"
                ></i>
              </el-button>
            </div>
          </el-col>
          <el-col
            :xs="24"
            :lg="16"
            :style="screenWidth < 1200 ? 'display:none' : 'display:block'"
          >
            <div class="loadBtn" style="float: right">
              <el-button
                type="primary"
                class="bg5584FF"
                style="margin-left: 40px"
                @click="openLoadWindow"
                >批量导入项目</el-button
              >
              <el-button type="primary" class="bg5584FF" @click="batchUse"
                >批量启用项目</el-button
              >
              <el-button type="primary" class="bg5584FF" @click="batchStop"
                >批量停用项目</el-button
              >
            </div>
          </el-col>
        </el-row>
      </div>
      <transition name="hr">
        <hr v-show="!showSearch" />
      </transition>
      <transition name="search">
        <div class="searchBox" v-show="showSearch">
          <!-- <div class="H40"></div> -->
          <el-form
            :inline="true"
            class="demo-form-inline"
            label-position="right"
            ref="searchForm"
            :model="searchObj"
          >
            <el-row style="width: 100%">
              <el-col :xs="24" :lg="6">
                <el-form-item label="项目名" class="w24">
                  <el-input
                    v-model.trim="searchObj.projectName"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :lg="6">
                <el-form-item label="项目编号" class="w24">
                  <el-input
                    v-model.trim="searchObj.projectCode"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :lg="6">
                <el-form-item label="项目状态" class="w24">
                  <el-select
                    v-model="searchObj.state"
                    clearable
                    placeholder="请选择"
                    filterable
                  >
                    <el-option label="不限" value></el-option>
                    <el-option label="启用" :value="0"></el-option>
                    <el-option label="停用" :value="1"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :lg="6">
                <el-form-item label="所在区县" class="w24">
                  <el-select
                    v-model="searchObj.area"
                    clearable
                    placeholder="请选择"
                    filterable
                  >
                    <el-option label="不限" value></el-option>
                    <el-option
                      v-for="(item, index) in areaList"
                      :key="index"
                      :label="item.name"
                      :value="item.name"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row style="width: 100%">
              <el-col :xs="24" :lg="6">
                <el-form-item label="企业名" class="w24">
                  <el-input
                    v-model.trim="searchObj.enterpriseName"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :lg="6">
                <el-form-item label="统一信用代码" class="w24">
                  <el-input
                    v-model.trim="searchObj.socialCredit"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :lg="12">
                <div class="w50">
                  <el-row style="width: 100%">
                    <el-col :xs="24" :lg="12">
                      <el-form-item
                        label="总投资金额(万元)"
                        class="halfOne"
                        :rules="startRule('investEnd')"
                        prop="investStart"
                      >
                        <el-input
                          v-model.trim="searchObj.investStart"
                          placeholder="请输入"
                          @change="handleMinChange('investEnd')"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :lg="12">
                      <el-form-item
                        label="~"
                        class="halfTwo"
                        :rules="endRule('investStart')"
                        prop="investEnd"
                      >
                        <el-input
                          v-model.trim="searchObj.investEnd"
                          placeholder="请输入"
                          @change="handleMaxChange('investStart')"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
              </el-col>
            </el-row>

            <el-row style="width: 100%">
              <el-col :xs="24" :lg="12">
                <div class="w50">
                  <el-row style="width: 100%">
                    <el-col :xs="24" :lg="12">
                      <el-form-item
                        label="今年计划投资(万元)"
                        class="halfOne"
                        :rules="startRule('planEnd')"
                        prop="planStart"
                      >
                        <el-input
                          v-model.trim="searchObj.planStart"
                          placeholder="请输入"
                          @change="handleMinChange('planEnd')"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :lg="12">
                      <el-form-item
                        label="~"
                        class="halfTwo"
                        :rules="endRule('planStart')"
                        prop="planEnd"
                      >
                        <el-input
                          v-model.trim="searchObj.planEnd"
                          placeholder="请输入"
                          @change="handleMaxChange('planStart')"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
              </el-col>
              <el-col :xs="24" :lg="12">
                <div class="w50">
                  <el-row style="width: 100%">
                    <el-col :xs="24" :lg="12">
                      <el-form-item
                        label="今年已完成投资(万元)"
                        class="halfOne"
                        label-width="190px"
                        :rules="startRule('haveEnd')"
                        prop="haveStart"
                      >
                        <el-input
                          v-model.trim="searchObj.haveStart"
                          placeholder="请输入"
                          @change="handleMinChange('haveEnd')"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :lg="12">
                      <el-form-item
                        label="~"
                        :rules="endRule('haveStart')"
                        prop="haveEnd"
                        class="halfTwo"
                      >
                        <el-input
                          v-model.trim="searchObj.haveEnd"
                          placeholder="请输入"
                          @change="handleMaxChange('haveStart')"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
              </el-col>
            </el-row>
            <el-row style="width: 100%">
              <el-col :xs="24" :lg="6">
                <el-form-item label="计划开工时间" class="w49 mr1">
                  <el-date-picker
                    v-model="planStartWork"
                    type="daterange"
                    range-separator="~"
                    start-placeholder="请选择"
                    end-placeholder="请选择"
                    value-format="yyyy-MM-dd"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :lg="6">
                <el-form-item label="计划竣工时间" class="w49">
                  <el-date-picker
                    v-model="planEndWork"
                    type="daterange"
                    range-separator="~"
                    start-placeholder="请选择"
                    end-placeholder="请选择"
                    value-format="yyyy-MM-dd"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :lg="6">
                <el-form-item label="项目入库时间" class="w49">
                  <el-date-picker
                    v-model="projectIn"
                    type="daterange"
                    range-separator="~"
                    start-placeholder="请选择"
                    end-placeholder="请选择"
                    value-format="yyyy-MM-dd"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item>
              <el-button
                type="primary"
                class="bg5584FF formBotton"
                @click="doSearch"
                >查询</el-button
              >
              <el-button type="info" @click="onReset" class="formBotton"
                >重置</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </transition>
      <el-row style="background: #fff; padding: 0px 0 20px">
        <el-col
          :xs="24"
          :lg="12"
          :style="screenWidth > 1200 ? 'display:none' : 'display:block'"
          style="margin-bottom: 10px"
        >
          <div
            class="loadBtn"
            :style="screenWidth > 1200 ? 'float: right' : 'float: left'"
          >
            <el-button
              type="primary"
              class="bg5584FF"
              style="padding: 6px 6px"
              size="mini"
              @click="openLoadWindow"
              >批量导入项目</el-button
            >
            <el-button
              type="primary"
              class="bg5584FF"
              style="margin-left: 10px; padding: 6px 6px"
              size="mini"
              @click="batchUse"
              >批量启用项目</el-button
            >
            <el-button
              type="primary"
              class="bg5584FF"
              style="padding: 6px 6px"
              size="mini"
              @click="batchStop"
              >批量停用项目</el-button
            >
          </div>
        </el-col>
        <el-col :xs="24" :lg="12">
          <el-button
            type="primary"
            size="small"
            class="bg5584FF"
            @click="addNew"
          >
            <i class="el-icon-plus"></i> 新增项目
          </el-button>
        </el-col>
      </el-row>

      <div style="height: 20px"></div>
      <el-table
        :data="projectList"
        style="width: 100%"
        class="expandTable"
        @selection-change="handleSelectionChange"
        v-loading="loading"
        :header-cell-style="{
          backgroundColor: '#DCDFE6',
          color: '#000',
        }"
      >
        <el-table-column type="expand" width="20" fixed>
          <template slot-scope="props">
            <el-form label-position="right" inline class="demo-table-expand">
              <el-form-item label="项目编号：">
                <span>{{ props.row.projectCode }}</span>
              </el-form-item>
              <el-form-item label="企业名称：">
                <span>{{ props.row.enterpriseName }}</span>
              </el-form-item>
              <el-form-item label="统一社会信用代码：">
                <span>{{ props.row.socialCredit }}</span>
              </el-form-item>
              <el-form-item label="项目名称：">
                <span>{{ props.row.projectName }}</span>
              </el-form-item>
              <el-form-item label="建设内容：">
                <span>{{ props.row.construction }}</span>
              </el-form-item>
              <el-form-item label="建设地点：">
                <span>{{ props.row.constructionSite }}</span>
              </el-form-item>
              <el-form-item label="565 所属产业：">
                <span>{{ props.row.hangye }}</span>
              </el-form-item>
              <el-form-item label="项目状态（暨开竣工状态）：">
                <span>{{ props.row.projectState }}</span>
              </el-form-item>
              <el-form-item label="项目性质：">
                <span>{{ props.row.projectNature }}</span>
              </el-form-item>
              <el-form-item label="所属行业：">
                <span>{{ props.row.industry }}</span>
              </el-form-item>
              <el-form-item label="所属市、州：">
                <span>{{ props.row.city }}</span>
              </el-form-item>
              <el-form-item label="所属县区：">
                <span>{{ props.row.area }}</span>
              </el-form-item>
              <el-form-item label="所属园区：">
                <span>{{ props.row.park }}</span>
              </el-form-item>
              <el-form-item label="存在问题：">
                <span>{{ props.row.problems }}</span>
              </el-form-item>
              <el-form-item label="总投资：">
                <span>{{ props.row.investment }}</span>
              </el-form-item>
              <el-form-item label="截止目前总投资：">
                <span>{{ props.row.investmentCompleted }}</span>
              </el-form-item>
              <el-form-item label="今年计划投资：">
                <span>{{ props.row.planned }}</span>
              </el-form-item>
              <el-form-item label="今年已完成投资：">
                <span>{{ props.row.complete }}</span>
              </el-form-item>
              <el-form-item label="明年计划投资：">
                <span>{{ props.row.nextPlaned }}</span>
              </el-form-item>
              <el-form-item label="资金来源：">
                <span v-if="props.row.funds == 1">贷款</span>
                <span v-else-if="props.row.funds == 2">自筹</span>
                <span v-else-if="props.row.funds == 3">混合</span>
                <span v-else>其他</span>
              </el-form-item>
              <el-form-item label="计划开工时间：">
                <span>{{ props.row.startPlanTime }}</span>
              </el-form-item>
              <el-form-item label="项目建设期：">
                <span>{{ props.row.period }}</span>
              </el-form-item>
              <el-form-item label="计划竣工时间：">
                <span>{{ props.row.endPlanTime }}</span>
              </el-form-item>
              <el-form-item label="本月形象进度：">
                <span>{{ props.row.effect }}</span>
              </el-form-item>
              <el-form-item label="改造项目实施后效果：">
                <span>{{ props.row.progress }}</span>
              </el-form-item>
              <el-form-item label="入库时间：">
                <span>{{ props.row.depositTime }}</span>
              </el-form-item>
              <el-form-item label="项目本系统状态：">
                <span>{{ props.row.state == 1 ? "禁用" : "启用" }}</span>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column label="项目编号" prop="projectCode"></el-table-column>
        <el-table-column label="项目名称" prop="projectName">
          <template slot-scope="scope">
            <span @click="detail(scope.row)" class="canClick">{{
              scope.row.projectName
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="项目状态" prop="state">
          <template slot-scope="scope">
            <span>{{ scope.row.state == 0 ? "启用" : "停用" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="所属县区" prop="area"></el-table-column>
        <el-table-column
          label="企业名称"
          prop="enterpriseName"
        ></el-table-column>
        <el-table-column
          label="统一社会信用代码"
          prop="socialCredit"
        ></el-table-column>
        <el-table-column align="center" label="操作" width="200">
          <template slot-scope="scope">
            <el-button
              size="mini"
              class="MR18 bg5584FF"
              type="primary"
              @click="editProject(scope.row)"
              >编辑</el-button
            >
            <!-- <el-button
            size="mini"
            class="MR18 bg5584FF"
            type="primary"
            @click="deleteGarden(scope.row)"
          >删除</el-button>-->
            <el-button
              size="mini"
              class="MR18 green"
              type="primary"
              @click="useProject(scope.row.id)"
              v-if="scope.row.state == 1"
              >启用</el-button
            >
            <el-button
              size="mini"
              class="MR18 red"
              type="primary"
              @click="openStopWindow(scope.row.id)"
              v-else
              >停用</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pageBox">
        <el-pagination
          class="pagePC"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="10"
          layout="total,  prev, pager, next"
          :total="totalNum"
        >
        </el-pagination>
        <van-pagination
          class="pagePhone"
          v-model="currentPage"
          :total-items="totalNum"
          :items-per-page="10"
          :show-page-size="3"
          @change="changePage"
          force-ellipses
        />
      </div>
      <!-- 停用弹框 -->
      <el-dialog
        title="停用"
        :visible.sync="showStopWindow"
        class="delete"
        :close-on-click-modal="false"
      >
        <p>是否确定停用项目信息？</p>
        <div class="btnBox MT40">
          <el-button
            type="primary"
            size="mini"
            class="bg5584FF"
            @click="stopProject"
            >确定</el-button
          >
          <el-button type="normal" size="mini" @click="showStopWindow = false"
            >取消</el-button
          >
        </div>
      </el-dialog>
      <!-- 批量停用弹框 -->
      <el-dialog
        title="停用"
        :visible.sync="showBatchStopWindow"
        class="delete"
        :close-on-click-modal="false"
      >
        <p>是否确定停用选中项目信息？</p>
        <div class="btnBox MT40">
          <el-button
            type="primary"
            size="mini"
            class="bg5584FF"
            @click="sureBatchStop"
            >确定</el-button
          >
          <el-button
            type="normal"
            size="mini"
            @click="showBatchStopWindow = false"
            >取消</el-button
          >
        </div>
      </el-dialog>
      <!-- 新增弹框 -->
      <el-dialog
        title="新建项目"
        :visible.sync="showAddWindow"
        :width="screenWidth < 1200 ? '96%' : '950px'"
        class="titleChange bodyScroll"
        :close-on-click-modal="false"
        :before-close="closeAdd"
      >
        <el-form
          :inline="true"
          :model="addObj"
          class="demo-form-inline half"
          size="mini"
          :label-width="screenWidth < 1200 ? '160px' : '220px'"
          label-position="right"
          ref="addForm"
          :rules="rules"
          v-loading="addLoading"
        >
          <div class="lineTitle" style="width: 100%">基本信息</div>
          <el-row>
            <el-col :xs="24" :lg="12">
              <el-form-item label="企业名称" prop="enterpriseName">
                <el-input
                  placeholder="请输入"
                  v-model.trim="addObj.enterpriseName"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="统一社会信用代码" prop="socialCredit">
                <el-input
                  placeholder="请输入"
                  v-model.trim="addObj.socialCredit"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="项目名称" prop="projectName">
                <el-input
                  placeholder="请输入"
                  v-model.trim="addObj.projectName"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="建设内容" prop="construction">
                <el-input
                  placeholder="请输入"
                  v-model.trim="addObj.construction"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="建设地点" prop="constructionSite">
                <el-input
                  placeholder="请输入"
                  v-model.trim="addObj.constructionSite"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="“565” 所属产业">
                <el-select
                  v-model="addObj.hangye"
                  clearable
                  placeholder="请选择"
                  filterable
                >
                  <el-option
                    v-for="(item, index) in fiveList"
                    :key="index"
                    :label="item.name"
                    :value="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="项目状态（暨开竣工状态）">
                <el-input
                  placeholder="请输入"
                  v-model.trim="addObj.projectState"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="项目性质（暨建设性质）">
                <el-select
                  v-model="addObj.projectNature"
                  clearable
                  placeholder="请选择"
                  filterable
                >
                  <el-option
                    v-for="(item, index) in projectNatureList"
                    :key="index"
                    :label="item.name"
                    :value="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="所属行业">
                <el-select
                  v-model="addObj.industry"
                  clearable
                  placeholder="请选择"
                  filterable
                >
                  <el-option
                    v-for="(item, index) in industryList"
                    :key="index"
                    :label="item.name"
                    :value="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="所属市、州">
                <el-input
                  placeholder="请输入"
                  v-model.trim="addObj.city"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="所属县（市）区" prop="area">
                <el-select
                  v-model="addObj.area"
                  clearable
                  placeholder="请选择"
                  filterable
                >
                  <el-option
                    v-for="(item, index) in areaList"
                    :key="index"
                    :label="item.name"
                    :value="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="所在园区">
                <el-select v-model="addObj.park" clearable placeholder="请选择">
                  <el-option
                    v-for="(item, index) in parkList"
                    :key="index"
                    :label="item.name"
                    :value="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="24">
              <el-form-item label="存在问题">
                <el-input
                  class="address_input_box"
                  type="textarea"
                  v-model.trim="addObj.problems"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <hr style="width: 100%; margin: 30px 0" />
          <div class="lineTitle" style="width: 100%">投资情况</div>
          <el-row>
            <el-col :xs="24" :lg="12">
              <el-form-item label="总投资（万元）" prop="investment">
                <el-input
                  v-model.trim="addObj.investment"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="今年计划投资（万元）" prop="planned">
                <el-input
                  v-model.trim="addObj.planned"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item
                label="截至目前已完成投资（万元）"
                prop="investmentCompleted"
              >
                <el-input
                  v-model.trim="addObj.investmentCompleted"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="今年完成投资（万元）" prop="complete">
                <el-input
                  v-model.trim="addObj.complete"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="明年计划投资（万元）" prop="nextPlaned">
                <el-input
                  v-model.trim="addObj.nextPlaned"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="资金来源" prop="funds">
                <el-select
                  v-model="addObj.funds"
                  clearable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(item, index) in fundsList"
                    :key="index"
                    :label="item.name"
                    :value="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <hr style="width: 100%; margin: 30px 0" />
          <div class="lineTitle" style="width: 100%">进度情况</div>
          <el-row>
            <el-col :xs="24" :lg="12">
              <el-form-item label="计划开工时间" prop="startPlanTime">
                <el-date-picker
                  v-model="addObj.startPlanTime"
                  type="date"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="项目建设期">
                <el-input
                  v-model="addObj.period"
                  placeholder="请输入（xx年xx月）"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="计划竣工时间" prop="endPlanTime">
                <el-date-picker
                  v-model="addObj.endPlanTime"
                  type="date"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="改造项目实施后效果">
                <el-select
                  v-model="addObj.progress"
                  clearable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(item, index) in progressList"
                    :key="index"
                    :label="item.name"
                    :value="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="24">
              <el-form-item label="本月形象进度">
                <el-input
                  class="address_input_box"
                  type="textarea"
                  v-model.trim="addObj.effect"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item style="width: 100%; text-align: center">
            <div class="btnBox">
              <el-button
                type="primary"
                size="mini"
                class="bg5584FF"
                @click="sureAdd"
                >新增</el-button
              >
              <el-button type="normal" size="mini" @click="closeAddBtn"
                >取消</el-button
              >
            </div>
          </el-form-item>
        </el-form>
      </el-dialog>
      <!-- 编辑弹框 -->
      <el-dialog
        title="编辑项目"
        :width="screenWidth < 1200 ? '96%' : '950px'"
        :visible.sync="showEditWindow"
        class="titleChange bodyScroll"
      >
        <el-form
          :inline="true"
          :model="editObj"
          class="demo-form-inline half"
          size="mini"
          :label-width="screenWidth < 1200 ? '160px' : '220px'"
          label-position="right"
          ref="editForm"
          :rules="editRules"
          v-loading="editLoading"
          :close-on-click-modal="false"
        >
          <div class="lineTitle" style="width: 100%">基本信息</div>
          <el-row>
            <el-col :xs="24" :lg="12">
              <el-form-item label="项目编号" prop="name">
                <el-input
                  placeholder="系统分配"
                  disabled
                  v-model="editObj.projectCode"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="企业名称" prop="enterpriseName">
                <el-input
                  placeholder="请输入"
                  v-model.trim="editObj.enterpriseName"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="统一社会信用代码" prop="socialCredit">
                <el-input
                  placeholder="请输入"
                  disabled
                  v-model="editObj.socialCredit"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="项目名称" prop="projectName">
                <el-input
                  placeholder="请输入"
                  v-model.trim="editObj.projectName"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="建设内容" prop="construction">
                <el-input
                  placeholder="请输入"
                  v-model.trim="editObj.construction"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="建设地点" prop="constructionSite">
                <el-input
                  placeholder="请输入"
                  v-model.trim="editObj.constructionSite"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="“565” 所属产业">
                <el-select
                  v-model="editObj.hangye"
                  clearable
                  placeholder="请选择"
                  filterable
                >
                  <el-option
                    v-for="(item, index) in fiveList"
                    :key="index"
                    :label="item.name"
                    :value="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="项目状态（暨开竣工状态）">
                <el-input
                  placeholder="请输入"
                  v-model.trim="editObj.projectState"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="项目性质（暨建设性质）">
                <el-select
                  v-model="editObj.projectNature"
                  clearable
                  placeholder="请选择"
                  filterable
                >
                  <el-option
                    v-for="(item, index) in projectNatureList"
                    :key="index"
                    :label="item.name"
                    :value="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="所属行业">
                <el-select
                  v-model="editObj.industry"
                  clearable
                  placeholder="请选择"
                  filterable
                >
                  <el-option
                    v-for="(item, index) in industryList"
                    :key="index"
                    :label="item.name"
                    :value="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="所属市、州">
                <el-input
                  placeholder="请输入"
                  v-model.trim="editObj.city"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="所属县（市）区" prop="area">
                <el-select
                  v-model="editObj.area"
                  clearable
                  placeholder="请选择"
                  filterable
                >
                  <el-option
                    v-for="(item, index) in areaList"
                    :key="index"
                    :label="item.name"
                    :value="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="所在园区">
                <el-select
                  v-model="editObj.park"
                  clearable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(item, index) in parkList"
                    :key="index"
                    :label="item.name"
                    :value="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="24">
              <el-form-item label="存在问题">
                <el-input
                  class="address_input_box"
                  type="textarea"
                  v-model.trim="editObj.problems"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <hr style="width: 100%; margin: 30px 0" />
          <div class="lineTitle" style="width: 100%">投资情况</div>
          <el-row>
            <el-col :xs="24" :lg="12">
              <el-form-item label="总投资（万元）" prop="investment">
                <el-input
                  v-model.trim="editObj.investment"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="今年计划投资（万元）" prop="planned">
                <el-input
                  v-model.trim="editObj.planned"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item
                label="截至目前已完成投资（万元）"
                prop="investmentCompleted"
              >
                <el-input
                  v-model.trim="editObj.investmentCompleted"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="今年完成投资（万元）" prop="complete">
                <el-input
                  v-model.trim="editObj.complete"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="明年计划投资（万元）" prop="nextPlaned">
                <el-input
                  v-model.trim="editObj.nextPlaned"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="资金来源" prop="funds">
                <el-select
                  v-model="editObj.funds"
                  clearable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(item, index) in fundsList"
                    :key="index"
                    :label="item.name"
                    :value="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <hr style="width: 100%; margin: 30px 0" />
          <div class="lineTitle" style="width: 100%">进度情况</div>
          <el-row>
            <el-col :xs="24" :lg="12">
              <el-form-item label="计划开工时间" prop="startPlanTime">
                <el-date-picker
                  v-model="editObj.startPlanTime"
                  type="date"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="项目建设期">
                <el-input
                  v-model="editObj.period"
                  placeholder="请输入（xx年xx月）"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="计划竣工时间" prop="endPlanTime">
                <el-date-picker
                  v-model="editObj.endPlanTime"
                  type="date"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="改造项目实施后效果">
                <el-select
                  v-model="editObj.progress"
                  clearable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(item, index) in progressList"
                    :key="index"
                    :label="item.name"
                    :value="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="24">
              <el-form-item label="本月形象进度">
                <el-input
                  class="address_input_box"
                  type="textarea"
                  v-model.trim="editObj.effect"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item style="width: 100%; text-align: center">
            <div class="btnBox">
              <el-button
                type="primary"
                size="mini"
                class="bg5584FF"
                @click="sureEdit"
                >确认修改</el-button
              >
              <el-button
                type="normal"
                size="mini"
                @click="showEditWindow = false"
                >取消</el-button
              >
            </div>
          </el-form-item>
        </el-form>
      </el-dialog>
      <!-- 详情弹框 -->
      <el-dialog
        title="项目详情"
        :visible.sync="showDetailWindow"
        :width="screenWidth < 1200 ? '96%' : '950px'"
        class="titleChange bodyScroll"
        :close-on-click-modal="false"
      >
        <el-form
          :inline="true"
          :model="detailObj"
          class="demo-form-inline half"
          size="mini"
          :label-width="screenWidth < 1200 ? '160px' : '200px'"
          label-position="right"
        >
          <div class="lineTitle" style="width: 100%">基本信息</div>
          <el-row>
            <el-col :xs="24" :lg="12">
              <el-form-item label="项目编号" prop="name">
                <el-input
                  placeholder="系统分配"
                  disabled
                  v-model="detailObj.projectCode"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="企业名称" prop="enterpriseName">
                <el-input
                  placeholder="请输入"
                  v-model="detailObj.enterpriseName"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="统一社会信用代码" prop="socialCredit">
                <el-input
                  placeholder="请输入"
                  disabled
                  v-model="detailObj.socialCredit"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="项目名称" prop="projectName">
                <el-input
                  placeholder="请输入"
                  v-model="detailObj.projectName"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="建设内容" prop="construction">
                <el-input
                  placeholder="请输入"
                  v-model="detailObj.construction"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="建设地点" prop="constructionSite">
                <el-input
                  placeholder="请输入"
                  v-model="detailObj.constructionSite"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="“565” 所属产业">
                <el-select
                  v-model="detailObj.hangye"
                  placeholder="请选择"
                  disabled
                  filterable
                >
                  <el-option
                    v-for="(item, index) in fiveList"
                    :key="index"
                    :label="item.name"
                    :value="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="项目状态（暨开竣工状态）">
                <el-input
                  placeholder="请输入"
                  v-model="detailObj.projectState"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="项目性质（暨建设性质）">
                <el-select
                  v-model="detailObj.projectNature"
                  placeholder="请选择"
                  filterable
                  disabled
                >
                  <el-option
                    v-for="(item, index) in projectNatureList"
                    :key="index"
                    :label="item.name"
                    :value="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="所属行业">
                <el-select
                  v-model="detailObj.industry"
                  placeholder="请选择"
                  filterable
                  disabled
                >
                  <el-option
                    v-for="(item, index) in industryList"
                    :key="index"
                    :label="item.name"
                    :value="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="所属市、州">
                <el-input
                  placeholder="请输入"
                  v-model="detailObj.city"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="所属县（市）区" prop="area">
                <el-select
                  v-model="detailObj.area"
                  placeholder="请选择"
                  filterable
                  disabled
                >
                  <el-option
                    v-for="(item, index) in areaList"
                    :key="index"
                    :label="item.name"
                    :value="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="所在园区">
                <el-select
                  v-model="detailObj.park"
                  placeholder="请选择"
                  disabled
                >
                  <el-option
                    v-for="(item, index) in parkList"
                    :key="index"
                    :label="item.name"
                    :value="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="24">
              <el-form-item label="存在问题">
                <el-input
                  class="address_input_box"
                  type="textarea"
                  v-model="detailObj.problems"
                  placeholder="请输入"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <hr style="width: 100%; margin: 30px 0" />
          <div class="lineTitle" style="width: 100%">投资情况</div>
          <el-row>
            <el-col :xs="24" :lg="12">
              <el-form-item label="总投资（万元）" prop="investment">
                <el-input
                  v-model="detailObj.investment"
                  placeholder="请输入"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="今年计划投资（万元）" prop="planned">
                <el-input
                  v-model="detailObj.planned"
                  placeholder="请输入"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item
                label="截至目前已完成投资（万元）"
                prop="investmentCompleted"
              >
                <el-input
                  v-model="detailObj.investmentCompleted"
                  placeholder="请输入"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="今年完成投资（万元）" prop="complete">
                <el-input
                  v-model="detailObj.complete"
                  placeholder="请输入"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="明年计划投资（万元）" prop="nextPlaned">
                <el-input
                  v-model="detailObj.nextPlaned"
                  placeholder="请输入"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="资金来源" prop="funds">
                <el-select
                  v-model="detailObj.funds"
                  placeholder="请选择"
                  disabled
                >
                  <el-option
                    v-for="(item, index) in fundsList"
                    :key="index"
                    :label="item.name"
                    :value="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <hr style="width: 100%; margin: 30px 0" />
          <div class="lineTitle" style="width: 100%">进度情况</div>
          <el-row>
            <el-col :xs="24" :lg="12">
              <el-form-item label="计划开工时间" prop="startPlanTime">
                <el-date-picker
                  v-model="detailObj.startPlanTime"
                  type="date"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                  disabled
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="项目建设期">
                <el-input
                  v-model="detailObj.period"
                  placeholder="请输入（xx年xx月）"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="计划竣工时间" prop="endPlanTime">
                <el-date-picker
                  v-model="detailObj.endPlanTime"
                  type="date"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                  disabled
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="改造项目实施后效果">
                <el-select
                  v-model="detailObj.progress"
                  placeholder="请选择"
                  disabled
                >
                  <el-option
                    v-for="(item, index) in progressList"
                    :key="index"
                    :label="item.name"
                    :value="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="24">
              <el-form-item label="本月形象进度">
                <el-input
                  class="address_input_box"
                  type="textarea"
                  v-model="detailObj.effect"
                  placeholder="请输入"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-dialog>
      <!-- 批量导入弹框 -->
      <el-dialog
        title="批量导入项目"
        :visible.sync="showLoadWindow"
        class="titleChange bodyScroll"
        :width="screenWidth < 1200 ? '96%' : '560px'"
        height="auto"
        :close-on-click-modal="false"
      >
        <el-form
          label-width="150px"
          :model="loadObj"
          :rules="loadRule"
          v-loading="upLoading"
        >
          <el-form-item label="是否覆盖历史数据：">
            <el-radio-group v-model="loadObj.isReset">
              <el-radio :label="0">是</el-radio>
              <el-radio :label="1">否</el-radio>
            </el-radio-group>
            <p style="height: 20px; margin: 0; line-height: 22px">
              （如果不历史覆盖，将只导入最新数据）
            </p>
          </el-form-item>
          <el-form-item label="请选择Excel文件：">
            <input
              type="file"
              @change="selectFile($event)"
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              single
              id="loadiFlieInput"
              style="display: none"
            />
            <el-button
              type="primary"
              size="mini"
              class="bg5584FF"
              @click="triggerSelect"
            >
              <img
                style="display: inline-block"
                src="@/assets/imgs/icon/icon_selectIcon.png"
              />&emsp;选择文件
            </el-button>
            <a
              :href="`${fileBaseUrl}/business/file/download/cbd711e285a643f0b99acd9e536b1416`"
              :class="screenWidth < 1200 ? '' : 'mL20'"
            >
              <el-button type="primary" class="bg5584FF" size="mini">
                <img
                  style="display: inline-block"
                  src="@/assets/imgs/icon/icon_loadIcon.png"
                />&emsp;下载项目导入模板
              </el-button>
            </a>
          </el-form-item>
          <el-form-item label>
            <div class="fileName">{{ upFile }}</div>
            <div>（文件必须为EXcel2003版本！）</div>
          </el-form-item>
        </el-form>
        <div class="btnBox MT40">
          <el-button
            type="primary"
            size="mini"
            class="bg5584FF"
            @click="sureLoad"
            >导入</el-button
          >
          <el-button type="normal" size="mini" @click="closeLoad"
            >取消</el-button
          >
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { Message } from "element-ui";
import { mapGetters } from "vuex";
export default {
  data() {
    var checkNum = (rule, value, callback) => {
      let reg = /^[0-9]+\.[0-9]{2}$/;
      if (value) {
        if (Number.isInteger(+value) && +value > 0) {
          callback();
        } else {
          if (!reg.test(+value) || +value < 0) {
            callback(new Error("请输入正值，保留两位小数"));
          } else {
            callback();
          }
        }
      } else {
        callback();
      }
    };
    var socialNum = (rule, value, callback) => {
      let reg = /^[0-9a-zA-Z]*$/g;
      if (reg.test(value) && value.length == 18) {
        callback();
      } else {
        callback(new Error("请输入18位合法编号"));
      }
    };
    return {
      screenWidth: document.body.clientWidth, // 屏幕宽
      screeHeight: document.body.clientHeight, // 屏幕高
      upLoading: false,
      showSearch: false,
      searchObj: {
        investStart: "",
        investEnd: "",
        projectName: "",
        projectCode: "",
        state: "",
        area: "",
        enterpriseName: "",
        socialCredit: "",
        planStart: "",
        planEnd: "",
        haveStart: "",
        haveEnd: "",
        investment: "",
        planned: "",
        complete: "",
        startPlanTime: "",
        endPlanTime: "",
        depositTime: "",
      },
      planStartWork: [],
      planEndWork: [],
      projectIn: [],
      projectList: [],
      addObj: {
        projectCode: "",
        enterpriseName: "",
        socialCredit: "",
        projectName: "",
        construction: "",
        constructionSite: "",
        hangye: "",
        projectState: "",
        projectNature: "",
        industry: "",
        city: "",
        area: "",
        park: "",
        problems: "",
        investment: "",
        investmentCompleted: "",
        planned: "",
        complete: "",
        nextPlaned: "",
        funds: "", //1=贷款，2=自筹，3=混合，4=其他
        startPlanTime: "",
        endPlanTime: "",
        effect: "",
        progress: "",
        period: "",
      },
      editObj: {},
      detailObj: {},
      loadObj: {
        isReset: 0,
        filePath: "",
      },
      fiveList: [], //565列表
      projectNatureList: [], //项目性质列表
      fundsList: [], //资金来源列表
      progressList: [], //形象进度列表
      industryList: [], //行业列表
      parkList: [], //园区列表
      currentId: "",
      fileBaseUrl: this.$GLOBAl.fileBaseUrl,
      loading: false,
      addLoading: false,
      editLoading: false,
      showStopWindow: false,
      showAddWindow: false,
      showEditWindow: false,
      showDetailWindow: false,
      showBatchStopWindow: false,
      showLoadWindow: false,
      upFile: "未选择任何文件",
      currentPage: 1,
      batchObj: {},
      pageObj: {},
      totalNum: 0,
      rules: {
        enterpriseName: [
          { required: true, message: "请填写企业名称", trigger: "blur" },
        ],
        socialCredit: [
          {
            required: true,
            message: "请填写统一社会信用代码",
            trigger: "blur",
          },
          { validator: socialNum, trigger: "blur" },
        ],
        projectName: [
          { required: true, message: "请填写项目名称", trigger: "blur" },
        ],
        construction: [
          { required: true, message: "请填写建设内容", trigger: "blur" },
        ],
        constructionSite: [
          { required: true, message: "请填写建设地点", trigger: "blur" },
        ],
        area: [
          {
            required: true,
            message: "请选择所属县（市）区",
            trigger: "change",
          },
        ],
        investment: [
          { required: true, message: "请输入总投资金额", trigger: "blur" },
          { validator: checkNum, trigger: "blur" },
        ],
        planned: [
          {
            required: true,
            message: "请输入今年计划投资金额",
            trigger: "blur",
          },
          { validator: checkNum, trigger: "blur" },
        ],
        nextPlaned: [
          { validator: checkNum, trigger: "blur" },
          { required: false, message: "", trigger: "blur" },
        ],
        complete: [
          {
            required: true,
            message: "请输入已完成投资金额",
            trigger: "blur",
          },
          { validator: checkNum, trigger: "blur" },
        ],
        investmentCompleted: [
          { required: true, message: "请输入截止目前金额", trigger: "blur" },
          { validator: checkNum, trigger: "blur" },
        ],
        startPlanTime: [
          { required: true, message: "请选择计划开工时间", trigger: "blur" },
        ],
        endPlanTime: [
          { required: true, message: "请选择计划竣工时间", trigger: "blur" },
        ],
      },
      editRules: {
        enterpriseName: [
          { required: true, message: "请填写企业名称", trigger: "blur" },
        ],
        projectName: [
          { required: true, message: "请填写项目名称", trigger: "blur" },
        ],
        construction: [
          { required: true, message: "请填写建设内容", trigger: "blur" },
        ],
        constructionSite: [
          { required: true, message: "请填写建设地点", trigger: "blur" },
        ],
        area: [
          {
            required: true,
            message: "请选择所属县（市）区",
            trigger: "change",
          },
        ],
        investment: [
          { required: true, message: "请输入总投资金额", trigger: "blur" },
          { validator: checkNum, trigger: "blur" },
        ],
        planned: [
          {
            required: true,
            message: "请输入今年计划投资金额",
            trigger: "blur",
          },
          { validator: checkNum, trigger: "blur" },
        ],
        nextPlaned: [
          { validator: checkNum, trigger: "blur" },
          { required: false, message: "", trigger: "blur" },
        ],
        complete: [
          {
            required: true,
            message: "请输入已完成投资金额",
            trigger: "blur",
          },
          { validator: checkNum, trigger: "blur" },
        ],
        investmentCompleted: [
          { required: true, message: "请输入截止目前金额", trigger: "blur" },
          { validator: checkNum, trigger: "blur" },
        ],
        startPlanTime: [
          { required: true, message: "请选择计划开工时间", trigger: "blur" },
        ],
        endPlanTime: [
          { required: true, message: "请选择计划竣工时间", trigger: "blur" },
        ],
      },
      loadRule: {},
    };
  },
  methods: {
    openSeach() {
      //打开搜索框
      this.showSearch = !this.showSearch;
    },
    handleSizeChange() {},
    changePage() {
      this.pageNum = this.currentPage;
      this.getProjectList(
        { pageNum: this.currentPage, pageSize: 10 },
        this.searchObj
      );
    },
    handleCurrentChange(val) {
      this.getProjectList({ pageNum: val, pageSize: 10 });
    },
    //批量导入项目
    openLoadWindow() {
      this.showLoadWindow = true;
    },
    triggerSelect() {
      document.getElementById("loadiFlieInput").click();
    },
    selectFile(e) {
      // let _this = this;
      let file = e.target.files[0];
      let formData = new FormData();
      // console.log("选中的文件", file);
      let fileName = file.name.substr(file.name.lastIndexOf(".") + 1);
      if (fileName !== "xls") {
        Message.error("请上传2003版本Excel文件");
        this.upFile = "未选择任何文件";
        document.getElementById("loadiFlieInput").value = "";
        return;
      }
      this.upFile = file.name;
      formData.append("file", file);
      this.loadObj.filePath = formData;
      // console.log("上传参数", this.loadObj);
    },
    //导入
    sureLoad() {
      if (!this.loadObj.filePath) {
        Message.error("请选择文件");
        return;
      }
      this.upLoading = true;
      this.$axios
        .post(
          `/business/project/importProject/${this.loadObj.isReset}`,
          this.loadObj.filePath
        )
        .then((res) => {
          // console.log("导入结果", res);
          Message.success("导入成功");
          this.loadObj.filePath = "";
          this.loadObj.isReset = 0;
          this.upFile = "";
          document.getElementById("loadiFlieInput").value = "";
          this.onReset();
          this.upLoading = false;
          this.showLoadWindow = false;
        })
        .catch((res) => {
          console.log("导入结果失败信息", res);
          this.upLoading = false;
        });
    },
    closeLoad() {
      this.loadObj.filePath = "";
      this.loadObj.isReset = 0;
      this.upFile = "未选择任何文件";
      document.getElementById("loadiFlieInput").value = "";
      this.showLoadWindow = false;
    },
    //批量停用项目
    batchStop() {
      this.batchObj.state = 1;
      this.showBatchStopWindow = true;
    },
    sureBatchStop() {
      if (!this.batchObj.ids) {
        Message.error("请勾选需要操作项目");
        this.showBatchStopWindow = false;
        return;
      }
      this.$axios
        .put("/business/project/updateState", this.batchObj)
        .then(() => {
          this.onReset();
          this.batchObj = {};
          this.showBatchStopWindow = false;
        })
        .catch((res) => {
          console.log("停用结果失败信息", res);
        });
    },
    // 批量启用
    batchUse() {
      if (!this.batchObj.ids) {
        Message.error("请勾选需要操作项目");
        return;
      }
      this.batchObj.state = 0;
      this.loading = true;
      this.$axios
        .put("/business/project/updateState", this.batchObj)
        .then(() => {
          this.onReset();
          this.batchObj = {};
          this.loading = false;
        })
        .catch((res) => {
          console.log("停用结果失败信息", res);
          this.loading = false;
        });
    },
    //搜索
    doSearch() {
      this.$refs.searchForm.validate((valid) => {
        if (valid) {
          // console.log("验证成功");
          this.searchObj.investment = `${this.searchObj.investStart}${
            this.searchObj.investStart && this.searchObj.investEnd ? "," : ""
          }${this.searchObj.investEnd}`;

          this.searchObj.planned = `${this.searchObj.planStart}${
            this.searchObj.planStart && this.searchObj.planEnd ? "," : ""
          }${this.searchObj.planEnd}`;

          this.searchObj.complete = `${this.searchObj.haveStart}${
            this.searchObj.haveStart && this.searchObj.haveEnd ? "," : ""
          }${this.searchObj.haveEnd}`;
          this.searchObj.startPlanTime =
            `${this.planStartWork[0] || ""},${this.planStartWork[1] || ""}` ==
            ","
              ? ""
              : `${this.planStartWork[0] || ""},${this.planStartWork[1] || ""}`;
          this.searchObj.endPlanTime =
            `${this.planEndWork[0] || ""},${this.planEndWork[1] || ""}` == ","
              ? ""
              : `${this.planEndWork[0] || ""},${this.planEndWork[1] || ""}`;
          this.searchObj.depositTime =
            `${this.projectIn[0] || ""},${this.projectIn[1] || ""}` == ","
              ? ""
              : `${this.projectIn[0] || ""},${this.projectIn[1] || ""}`;
          this.getProjectList({ pageNum: 1, pageSize: 10 }, this.searchObj);
        } else {
          Message.error("请检查查询参数");
        }
      });
    },
    onReset(norequest) {
      this.searchObj = {
        investStart: "",
        investEnd: "",
        projectName: "",
        projectCode: "",
        projectState: "",
        area: "",
        enterpriseName: "",
        socialCredit: "",
        planStart: "",
        planEnd: "",
        haveStart: "",
        haveEnd: "",
        planStartWork: [],
        planEndWork: [],
        projectIn: [],
        investment: "",
        planned: "",
        complete: "",
        startPlanTime: "",
        endPlanTime: "",
        depositTime: "",
      };
      this.getProjectList({ pageNum: 1, pageSize: 10 }, this.searchObj);
      this.currentPage = 1;
    },
    // 新建
    addNew() {
      this.showAddWindow = true;
    },
    // 确认新建
    sureAdd() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.addLoading = true;
          this.$axios
            .post("/business/project/insertProjectInfo", this.addObj)
            .then(() => {
              this.onReset();
              Message.success("新增项目成功");
              this.showAddWindow = false;
              this.addLoading = false;
              this.resetAddForm();
            })
            .catch((res) => {
              console.log("新增结果失败信息", res);
              this.addLoading = false;
            });
        } else {
          Message.error("请检查表单内容");
        }
      });
    },
    resetAddForm() {
      (this.addObj = {
        projectCode: "",
        enterpriseName: "",
        socialCredit: "",
        projectName: "",
        construction: "",
        constructionSite: "",
        hangye: "",
        projectState: "",
        projectNature: "",
        industry: "",
        city: this.seatList1.length > 0 ? this.seatList1[0] : "",
        area: "",
        park: "",
        problems: "",
        investment: "",
        investmentCompleted: "",
        planned: "",
        complete: "",
        nextPlaned: "",
        funds: "", //1=贷款，2=自筹，3=混合，4=其他
        startPlanTime: "",
        endPlanTime: "",
        effect: "",
        progress: "",
        period: "",
      }),
        this.$refs.addForm.resetFields();
    },
    closeAdd(done) {
      this.resetAddForm();
      done();
    },
    closeAddBtn() {
      this.resetAddForm();
      this.showAddWindow = false;
    },
    // 详情
    detail(row) {
      this.detailObj = row;
      this.showDetailWindow = true;
    },
    // 编辑
    editProject(row) {
      this.editObj = JSON.parse(JSON.stringify(row));
      this.showEditWindow = true;
    },
    // 确认编辑
    sureEdit() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.editLoading = true;
          this.$axios
            .put("/business/project/updateProjectInfo", this.editObj)
            .then(() => {
              this.onReset();
              Message.success("修改项目信息成功");
              this.showEditWindow = false;
              this.editLoading = false;
            })
            .catch((res) => {
              console.log("修改项目结果失败信息", res);
              this.editLoading = false;
            });
        } else {
          Message.error("请检查表单内容");
        }
      });
    },
    // 启用
    useProject(id) {
      this.loading = true;
      this.$axios
        .put("/business/project/updateState", { ids: [id], state: 0 })
        .then(() => {
          this.onReset();
          this.loading = false;
        })
        .catch((res) => {
          console.log("启用结果失败信息", res);
          this.loading = false;
        });
    },
    // 停用提示框
    openStopWindow(id) {
      this.currentId = id;
      this.showStopWindow = true;
    },
    // 停用
    stopProject() {
      this.loading = true;
      this.$axios
        .put("/business/project/updateState", {
          ids: [this.currentId],
          state: 1,
        })
        .then(() => {
          this.onReset();
          this.showStopWindow = false;
          this.loading = false;
        })
        .catch((res) => {
          console.log("停用结果失败信息", res);
          this.loading = false;
        });
    },
    // 多选
    handleSelectionChange(val) {
      let ids = val.map((res) => res.id);
      this.batchObj.ids = ids;
    },
    //搜索数字区间左侧验证
    startRule(key) {
      // 搜索数字验证
      var validateNum = (rule, value, callback) => {
        const MIN_NUMBER = 0;
        const one = Number(value);
        if (Number.isInteger(one)) {
          if (one < MIN_NUMBER) {
            return callback(new Error("输入值必须大于或等于0"));
          }
          return callback();
        }
        return callback(new Error("请输入整数值"));
      };
      var validateMin = (rule, value, callback) => {
        var one = Number(value);
        var max = Number(this.searchObj[key]);
        if (!max || one < max) {
          return callback();
        }
        return callback(new Error("输入值不得大于最大阈值"));
      };
      var Rule = [];
      Rule.push(
        { validator: validateNum, trigger: "blur" },
        { validator: validateMin, trigger: "blur" }
      );
      return Rule;
    },
    //搜索数字区间右侧验证
    endRule(key) {
      // 搜索数字验证
      var validateNum = (rule, value, callback) => {
        const MIN_NUMBER = 0;
        const one = Number(value);
        if (Number.isInteger(one)) {
          if (one && one <= MIN_NUMBER) {
            return callback(new Error("输入值必须大于0"));
          }
          return callback();
        }
        return callback(new Error("请输入整数值"));
      };
      var validateMax = (rule, value, callback) => {
        var one = Number(value);
        var min = Number(this.searchObj[key]);
        if (!min || one > min) {
          if (!min && one && min != 0) {
            return callback(new Error("请先输入最小值"));
          }
          return callback();
        }
        return callback(new Error("输入值不得小于最小阈值"));
      };
      var R = [];
      R.push(
        { validator: validateMax, trigger: "blur" },
        { validator: validateNum, trigger: "blur" }
      );
      return R;
    },
    handleMinChange(key) {
      this.$refs.searchForm.validateField(key);
    },
    handleMaxChange(key) {
      this.$refs.searchForm.validateField(key);
    },
    //获取项目列表
    getProjectList(pageObj, searchObj) {
      this.loading = true;
      let pms = Object.assign(pageObj, searchObj);
      this.$axios
        .get("/business/project/list", { params: pms })
        .then((res) => {
          // console.log("项目列表", res);
          this.projectList = res.data;
          this.totalNum = res.total;
          this.pageObj = searchObj;
          this.loading = false;
        })
        .catch((res) => {
          console.log("项目列表获取失败", res);
          this.loading = false;
        });
    },
    //获取下拉框列表
    getSelectList() {
      // 项目库565所属行业列表
      this.$axios.get("/business/project/hangye").then((res) => {
        this.fiveList = res.data;
      });
      // 项目行业列表
      this.$axios.get("/business/project/industry").then((res) => {
        this.industryList = res.data;
      });
      // 项目性质列表
      this.$axios.get("/business/project/nature").then((res) => {
        this.projectNatureList = res.data;
      });
      // 园区名列表
      this.$axios.get("/business/project/parkName").then((res) => {
        this.parkList = res.data;
      });
      // 项目进展列表
      this.$axios.get("/business/project/progress").then((res) => {
        this.progressList = res.data;
      });
      // 资金来源列表
      this.$axios.get("/business/project/funds").then((res) => {
        this.fundsList = res.data;
      });
    },
  },
  mounted() {
    window.onresize = () => {
      this.screenWidth = document.body.clientWidth;
    };
  },
  created() {
    if (this.seatList1.length) {
      this.addObj.city = this.seatList1[0];
    }

    this.getProjectList({ pageNum: 1, pageSize: 10 });
    this.getSelectList();
  },
  computed: {
    ...mapGetters({
      areaList: "getAreaLists",
      seatList1: "getAreaListArr",
    }),
  },
};
</script>

<style lang="less" scoped>
.topBtnBox {
  display: flex;
  justify-content: space-between;
  i.show {
    animation: showRotate 0.5s forwards;
  }
  i.close {
    animation: closeRotate 0.5s forwards;
  }
}
@keyframes showRotate {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(180deg);
  }
}
@keyframes closeRotate {
  from {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(0);
  }
}
hr {
  border-color: rgba(155, 155, 155, 0.2);
  margin: 30px 0 20px;
}
.searchBox {
  overflow: hidden;
  overflow-y: auto;
  height: auto;
  margin-bottom: 20px;
  background-color: rgba(173, 173, 173, 0.02);
  border-radius: 2px;
  padding: 0 10px;
  // border: 1px solid rgba(114, 114, 114, 0.15);
  margin-top: 30px;
  .el-form {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    /deep/ .w24 {
      // width: 23%;
      display: flex;
      .el-form-item__label {
        min-width: 110px;
      }
      .el-form-item__content {
        flex: 1;
      }
    }
    /deep/ .w50 {
      // width: 50%;
      display: flex;
      .halfOne {
        // width: 55%;
        display: flex;
        .el-form-item__label {
          min-width: 150px;
        }
        .el-form-item__content {
          flex: 1;
        }
      }
      .halfTwo {
        // width: 45%;
        display: flex;
        .el-form-item__label {
          min-width: 30px;
        }
        @media (max-width: 1200px) {
          .el-form-item__label {
            min-width: 150px;
          }
        }

        .el-form-item__content {
          flex: 1;
        }
      }
    }
    /deep/ .w49 {
      // width: 48%;
      display: flex;
      .el-form-item__content {
        flex: 1;
        .el-date-editor {
          width: 100%;
        }
      }
    }
    .mr1 {
      margin-right: 1%;
    }
    // .item {
    //   width: 37%;
    //   display: flex;
    //   .el-form-item.halfOne {
    //     width: 55%;
    //     display: flex;
    //   }
    //   .el-form-item.halfTwo {
    //     width: 45%;
    //     display: flex;
    //   }
    // }
  }
}
.search-leave-active,
.search-enter-active {
  transition: all 0.8s ease;
}
.search-leave-active,
.search-enter {
  height: 0px !important;
}
.search-leave,
.search-enter-active {
  height: 350px;
}
.hr-enter-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
  transition-delay: 0.2s;
}
.hr-leave-active {
  transition: all 0s cubic-bezier(1, 0.5, 0.8, 1);
}
.hr-enter,
.hr-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
.fileName {
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  text-indent: 1em;
  font-weight: bolder;
}
.content_box {
  padding: 20px 30px 30px;
}

.content_box_inner {
  padding: 10px 20px 20px;
  box-shadow: 0px 0px 50px #ccc;
}
.pagePhone {
  display: none;
}

@media (max-width: 1200px) {
  .content_box {
    padding: 20px 10px 30px;
  }
  .content_box_inner {
    padding: 10px 10px 20px;
  }
  .pagePC {
    display: none;
  }
  .pagePhone {
    display: flex;
  }
  .noticeFont {
    font-size: 10px;
  }
}
.topBtnBox i.show {
  display: inline-block !important;
}
</style>